/**
 * Filters out skills that the user already has from the full options list.
 * Compares by `value` field, with fallback to `type_of_certification`.
 *
 * @param {Array} allSkills - Full dropdown options (each with a `value` field)
 * @param {Array} userSkills - User's current skills (each with `value` or `type_of_certification`)
 * @returns {Array} Options not yet assigned to the user
 */
export const diffSkill = (allSkills, userSkills) => {
  if (!allSkills || allSkills.length === 0) return []
  if (!userSkills || userSkills.length === 0) return allSkills

  return allSkills.filter((option) => {
    if (!option || !option.value) return false

    const isDuplicate = userSkills.some((us) => {
      if (us.value && option.value === us.value) return true
      if (us.type_of_certification && option.value === us.type_of_certification) return true
      return false
    })

    return !isDuplicate
  })
}
